import { render, staticRenderFns } from "./QuestionsPage.vue?vue&type=template&id=8775af4a&scoped=true"
import script from "./QuestionsPage.vue?vue&type=script&lang=js"
export * from "./QuestionsPage.vue?vue&type=script&lang=js"
import style0 from "./QuestionsPage.vue?vue&type=style&index=0&id=8775af4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8775af4a",
  null
  
)

export default component.exports